import { render } from "./Champions.vue?vue&type=template&id=11007236"
import script from "./Champions.vue?vue&type=script&lang=js"
export * from "./Champions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Champions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "11007236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('11007236', __exports__)) {
    api.reload('11007236', __exports__)
  }
  
  module.hot.accept("./Champions.vue?vue&type=template&id=11007236", () => {
    api.rerender('11007236', render)
  })

}


export default __exports__